import { TodoNotification } from '../../types'
import { NotificationSubjectType } from 'types'
import { articleOrLayerPath } from '../../utils'

export const pathForTodoNotification = (notification: TodoNotification) => {
  switch (notification.subject.subject_type) {
    case NotificationSubjectType.TodoCompleted:
      return articleOrLayerPath({
        notification,
        right_rail: 'Tasks',
        commentsFilter: 'resolved',
        id: notification.subject.id,
      })
    case NotificationSubjectType.TodoDeleted:
      return articleOrLayerPath({ notification })
    case NotificationSubjectType.Todo:
    case NotificationSubjectType.TodoUpdated:
    case NotificationSubjectType.TodoAssigneeUpdated:
    case NotificationSubjectType.TodoCommentCreated:
    case NotificationSubjectType.TodoDueDateUpdated:
    case NotificationSubjectType.TodoUncompleted:
    default:
      return articleOrLayerPath({
        notification,
        right_rail: 'Tasks',
        commentsFilter: 'all',
        id: notification.subject.id,
      })
  }
}

export const titleForTodoType = (subjectType: string, assignedToMe: boolean) => {
  switch (subjectType) {
    case NotificationSubjectType.TodoUpdated:
    case NotificationSubjectType.TodoAssigneeUpdated:
    case NotificationSubjectType.TodoDueDateUpdated:
      return 'updated a task'
    case NotificationSubjectType.TodoCompleted:
      return 'completed a task'
    case NotificationSubjectType.TodoCommentCreated:
      return 'left a comment on a task'
    case NotificationSubjectType.TodoDeleted:
      return 'deleted a task'
    case NotificationSubjectType.TodoUncompleted:
      return 'uncompleted a task'
    case NotificationSubjectType.Todo:
    default:
      if (assignedToMe) return 'assigned you a task'

      return 'created a task'
  }
}
